
import { Component, OnInit } from '@angular/core';
import { Storage } from '@ionic/storage';
import { NavController, AlertController, ToastController } from '@ionic/angular';
import { NavigationExtras, Router } from '@angular/router';
import { UtilService } from '../../service/util.service';
import { UserProfile } from '../../models/user-profile.model';
import { UserData } from '../../providers/user-data';
import { SetupTourGuideService } from './setup-tour-guide.service';
import { RoleAccess } from '../../models/role-access.model';
import { AES } from 'crypto-js';
import { environment } from '../../../environments/environment';
@Component({
  selector: 'app-setup-tour-guide',
  templateUrl: './setup-tour-guide.page.html',
  styleUrls: ['./setup-tour-guide.page.scss'],
})
export class SetupTourGuidePage implements OnInit {
  page = {
    limit: 10,
    count: 0,
    offset: 0,
    orderBy: 'Name',
    orderDir: 'desc'
  };

  rows: any;
  token: any;
  userProfile: UserProfile = new UserProfile();
  roleListData: any[] = [];
  userList: any;
  filteredData: any;

  keywordSearch: any;
  roleAccess = new RoleAccess();
  statusName:any[]=['Not Active','Active'];
  constructor(
    private storage: Storage,
    private navCtrl: NavController,
    private utilService: UtilService,
    private alertController: AlertController,
    private toastCtrl: ToastController,
    private userData: UserData,
    private setupTourGuideService: SetupTourGuideService,
    private router: Router
  ) { }

  ngOnInit() {
  }

  ionViewDidEnter() {
    Promise.all([
      this.storage.get('user_token'),
      this.storage.get('user_profile'),
       this.storage.get('user_menu_access')
    ])
    .then(([token, profile, access]) => {
      if(token) {
        this.token = token;
        this.userProfile = new UserProfile(profile);
        this.roleAccess = this.userData.checkAccess(this.router.url, access, this.userProfile);
        if(!this.roleAccess || this.roleAccess.view!='1'){
          this.toastCtrl.create({ duration: 2000, message: 'You Are Not Allowed to Access this Page' }).then(t => t.present());
          this.navCtrl.navigateForward(['/']);
       }
        else{
          this.pageCallback({ offset: this.page.offset });
        }
      } else {
        this.toastCtrl.create({ duration: 2000, message: 'Silahkan login terlebih dahulu.' }).then(t => t.present());
        this.navCtrl.navigateForward(['/login']);
      }
    });

  }

  pageCallback(pageInfo: { count?: number, pageSize?: number, limit?: number, offset?: number }) {
    this.page.offset = pageInfo.offset;
    this.reloadTable();
  }
  
  sortCallback(sortInfo: { sorts: { dir: string, prop: string }[], column: {}, prevValue: string, newValue: string }) {
    this.page.orderDir = sortInfo.sorts[0].dir;
    this.page.orderBy = sortInfo.sorts[0].prop;
    this.reloadTable();
  }

  reloadTable() {
    this.utilService.loadingPresent('Harap tunggu...')
    .then(() => {
      let offset = this.page.offset + 1;
      let options = {
        "token": this.token,
        "page": offset.toString(),
        "keywords": this.keywordSearch ? this.keywordSearch : ''
      }
      this.setupTourGuideService.getSetupTourGuide(options).subscribe((response) => {
        this.utilService.loadingDismiss();
        this.page.count = response.results.total;
        this.rows = response.results.data;
        this.filteredData = response.results.data;
        this.userList = response.results.data;
      }, (err) => {
        this.utilService.loadingDismiss();
        console.log(err);
        if(err.error.error === 'token_expired') {
          this.userData.logout().then(() => {
            this.toastCtrl.create({ duration: 2000, message: 'Token telah expired. Silahkan login kembali' }).then(t => t.present());
            this.navCtrl.navigateForward(['/login']);
          });
        } else {
          this.toastCtrl.create({ duration: 2000, message: 'Gagal terhubung ke server' }).then(t => t.present());
        }
      });
    });
  }


  filterDatatable(event) {
    let val = event.target.value.toLowerCase();
    let columnLength = 13;
    let keys = Object.keys(this.userList[0]);
    this.rows = this.filteredData.filter(function(item){
      for (let i=0; i < columnLength; i++){
        if(item[keys[i]] !== null) {
          if (item[keys[i]].toString().toLowerCase().indexOf(val) !== -1 || !val){
            return true;
          }
        }
      }
    });

    this.page.offset = 0;
  }
  goToSetupTourGuideCreate() {
    let myKey = environment.myKey;
    let encryptID = AES.encrypt(JSON.stringify(0),myKey).toString();
    let encryptType = AES.encrypt('add',myKey).toString();
    let navigationExtras: NavigationExtras = {
      queryParams: {
        i: encryptID,
        a:encryptType
      }
    };
    this.navCtrl.navigateForward(['/setup-tour-guide/setup-tour-guide-form'], navigationExtras);
  }

  goToUpdateSetupTourGuidePage(id: any) {
    let myKey = environment.myKey;
    let encryptID = AES.encrypt(JSON.stringify(id),myKey).toString();
    let encryptType = AES.encrypt('update',myKey).toString();
    let navigationExtras: NavigationExtras = {
      queryParams: {
        i: encryptID,
        a:encryptType
      }
    };
    this.navCtrl.navigateForward(['/setup-tour-guide/setup-tour-guide-form'], navigationExtras);
  }
}